import { Category } from '@modules/common/types';
import { getEdgeCategoryTypeFromString } from '@modules/common/utils';
import { QuickFilterParams } from '@modules/queryBuilder/hooks/useAddQuickFilter';
import { FieldNames } from 'v2/core/entities/fields';

interface GetQuickFilterParamsForFieldOptions {
  fieldName: FieldNames;
  value: string;
  metadataQbField?: string; // Format: `${source}.{metadataFieldValue}`
  category?: Category;
}

export const getQuickFilterParamsForField = ({
  fieldName,
  value,
  metadataQbField,
  category,
}: GetQuickFilterParamsForFieldOptions): QuickFilterParams[] => {
  const field = metadataQbField || fieldName;

  const filterParams: QuickFilterParams[] = [
    {
      field,
      values: [value],
    },
  ];

  const categoryValue =
    field === FieldNames.Entity && category
      ? getEdgeCategoryTypeFromString(category)?.toLowerCase()
      : undefined;

  if (categoryValue) {
    filterParams.push({
      field: 'category',
      values: [categoryValue],
    });
  }

  return filterParams;
};
